export default "__VITE_ASSET__6WeDywXi__"